import React from "react";
import alertIcon from "../../../../assests/img/alert-icons.svg";
import ModalContainer from "Components/Common/Modal/ModalContainer";
import ModalBody from "Components/Common/Modal/ModalBody";
import ModalHeader from "Components/Common/Modal/ModalHeader";
import FillButton from "Components/Common/components/Button/FillButton";
import BorderedButton from "Components/Common/components/Button/BorderedButton";

const ProductDeleteConfirmationModal = ({ showModal, closeModal, totalProducts, onConfirm, loading }: any) => {
  return (<ModalContainer
    isOpen={showModal}
    setOpen={closeModal}
  >
    <ModalHeader>
      <div className=" tw-py-2">
        <h5 className="tw-text-xl tw-font-bold">Bulk delete products</h5> 
        <span>{totalProducts} {totalProducts === 1 ? "Product" : "Products"} found</span>
      </div>
    </ModalHeader>
    <ModalBody>
      <div className="tw-space-y-3 tw-py-4">
      <div className="tw-bg-red-50 tw-flex tw-space-x-3 tw-items-center tw-p-2 tw-px-3 tw-rounded ">
        <img className="alert-icons" src={alertIcon} alt="Alert icon" />
        <p>
          This action will permanently delete the {totalProducts === 1 ? "product" : "products"} or remove {totalProducts === 1 ? "its" : "their"} channel dependency if {totalProducts === 1 ? "it is" : "they are"} mapped to multiple channels.
        </p>
      </div>
      <center><p>Would you like to proceed?</p></center>
      <div className="tw-flex tw-justify-center tw-space-x-3">
        <BorderedButton onClick={() => closeModal()}>Cancel</BorderedButton>
        <FillButton 
        className={`!tw-border-red-500 !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`}
        onClick={() => onConfirm()}
        disabledClassName = "!tw-border-red-200 !tw-bg-red-200"
        disabled = {loading}
        >Delete</FillButton>
      </div>
      </div>
    </ModalBody>
  </ModalContainer>)
}

export default ProductDeleteConfirmationModal